// @generated by TypeGen from LogbookApi/LogApi - DO NOT EDIT

import type { ILogUpdateRequest } from "../LogbookApp/LogApi"
import type { IAppResponse } from "../LogbookApp/Routes"
import type { IEngineUpdateRequest, ISailUpdateRequest } from "../LogbookApp/StatusApi"
import type { ILogResponse, ILogsResponse } from "../LogbookModel/Log"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface LogApiEndpoints {
  "GET /api/ships/:shipId/days/:dayId/logs": {
    params: { shipId: number; dayId: number };
    query: {};
    request: never;
    response: ILogsResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "PUT /api/ships/:shipId/logs/:logId": {
    params: { shipId: number; logId: number };
    query: {};
    request: ILogUpdateRequest;
    response: ILogResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "PUT /api/ships/:shipId/logs/:logId/engine": {
    params: { shipId: number; logId: number };
    query: {};
    request: IEngineUpdateRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "PUT /api/ships/:shipId/logs/:logId/sails": {
    params: { shipId: number; logId: number };
    query: {};
    request: ISailUpdateRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
}

export const logApiEndpoints = {
  "GET /api/ships/:shipId/days/:dayId/logs": { targets: ["app", "server"], permission: { ship: IShipUserLevel.viewAll } },
  "PUT /api/ships/:shipId/logs/:logId": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
  "PUT /api/ships/:shipId/logs/:logId/engine": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
  "PUT /api/ships/:shipId/logs/:logId/sails": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
} as const;

export class LogApi {
  constructor(private client: ApiClient) {}

  logs = {
    list: (a: ApiArgs<LogApiEndpoints, "GET /api/ships/:shipId/days/:dayId/logs">) => ({
      call: (): Promise<ILogsResponse> => {
        assertTarget(this.client, "GET /api/ships/:shipId/days/:dayId/logs", logApiEndpoints["GET /api/ships/:shipId/days/:dayId/logs"].targets);
        return this.client.call<ILogsResponse>("GET /api/ships/:shipId/days/:dayId/logs", a);
      },
      url: (): string => this.client.url("GET /api/ships/:shipId/days/:dayId/logs", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.viewAll,
    }),
    update: (a: ApiArgs<LogApiEndpoints, "PUT /api/ships/:shipId/logs/:logId">) => ({
      call: (): Promise<ILogResponse> => {
        assertTarget(this.client, "PUT /api/ships/:shipId/logs/:logId", logApiEndpoints["PUT /api/ships/:shipId/logs/:logId"].targets);
        return this.client.call<ILogResponse>("PUT /api/ships/:shipId/logs/:logId", a);
      },
      url: (): string => this.client.url("PUT /api/ships/:shipId/logs/:logId", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.editCurrent,
    }),
    updateEngine: (a: ApiArgs<LogApiEndpoints, "PUT /api/ships/:shipId/logs/:logId/engine">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "PUT /api/ships/:shipId/logs/:logId/engine", logApiEndpoints["PUT /api/ships/:shipId/logs/:logId/engine"].targets);
        return this.client.call<IAppResponse>("PUT /api/ships/:shipId/logs/:logId/engine", a);
      },
      url: (): string => this.client.url("PUT /api/ships/:shipId/logs/:logId/engine", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.editCurrent,
    }),
    updateSails: (a: ApiArgs<LogApiEndpoints, "PUT /api/ships/:shipId/logs/:logId/sails">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "PUT /api/ships/:shipId/logs/:logId/sails", logApiEndpoints["PUT /api/ships/:shipId/logs/:logId/sails"].targets);
        return this.client.call<IAppResponse>("PUT /api/ships/:shipId/logs/:logId/sails", a);
      },
      url: (): string => this.client.url("PUT /api/ships/:shipId/logs/:logId/sails", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.editCurrent,
    }),
  };
}
